export const initSelect2 = (controller) => {
  $(controller.element).find("select").select2({ width: "100%" });

  $(document).on("cocoon:after-insert", () => {
    $(controller.element).find("select").select2();
  });
}
